/**
 * Please keep an alphabetical order.
 */
export const CLIENT_INSTRUMENTATION_EVENT_TYPES = [
  'Add component',
  'Add evaluation',
  'Add page',
  'AI scope recommendation rejected',
  'apply ai report filters',
  'automatic_validation_setting_saved',
  'Component added to evaluation',
  'Component saved',
  'conformance score trend range selected',
  'Delete AI chat',
  'delete schedule report',
  'digital_asset_activity_filter_used',
  'digital_asset_activity_log_read',
  'digital_asset_activity_page',
  'duplicate custom report',
  'Edit component',
  'Edit page',
  'edit report',
  'export custom report',
  'manage custom report',
  'New AI chat',
  'Open AI chat',
  'Page added to evaluation',
  'Page saved',
  'PDF Auto Remediation Requested',
  'Plugin Downloaded',
  'program_portfolio_access_denied',
  'program_portfolio_page_viewed',
  'Project Tasks Filter Applied',
  'Project Tasks Sorted',
  'Push tasks to GitHub in bulk',
  'regenerate custom report',
  'restore report',
  'risk management status section expanded',
  'schedule report',
  'Send question AI chat',
  'share custom report',
  'stop generate report',
  'Submit rating AI chat',
  'user_management.bulk_action_cancelled',
  'user_management.bulk_action_committed',
  'user_management.bulk_action_opened',
  'user_management.bulk_confirmation_viewed',
  'user_management.bulk_partial_failure',
  'user_management.bulk_selection_changed',
  'user_management.details_saved',
  'user_management.indeterminate_block_shown',
  'user_management.invite_blocked',
  'user_management.invite_emails_parsed',
  'user_management.invite_panel_opened',
  'user_management.invite_resent',
  'user_management.invite_revoked',
  'user_management.invite_submitted',
  'user_management.list_filtered',
  'user_management.list_paginated',
  'user_management.list_searched',
  'user_management.list_sorted',
  'user_management.list_viewed',
  'user_management.page_size_changed',
  'user_management.permissions_saved',
  'user_management.removal_blocked',
  'user_management.save_conflict',
  'user_management.scim_banner_shown',
  'user_management.scim_edit_committed',
  'user_management.slideout_abandoned',
  'user_management.slideout_opened',
  'view create report page',
  'view custom report page',
  'view linked comments',
  'view report history',
  'view saved report',
] as const;
export type ClientInstrumentationEventType = (typeof CLIENT_INSTRUMENTATION_EVENT_TYPES)[number];

export const AI_CHAT_INSTRUMENTATION_EVENTS = {
  OPEN_AI_CHAT: 'Open AI chat',
  SEND_QUESTION_AI_CHAT: 'Send question AI chat',
  SUBMIT_RATING_AI_CHAT: 'Submit rating AI chat',
  NEW_AI_CHAT: 'New AI chat',
  DELETE_AI_CHAT: 'Delete AI chat',
} as const;

export const AI_CHAT_EVENT_TYPES: ReadonlySet<string> = new Set(Object.values(AI_CHAT_INSTRUMENTATION_EVENTS));

export function isAiChatEvent(eventType: string | undefined): boolean {
  return typeof eventType === 'string' && AI_CHAT_EVENT_TYPES.has(eventType);
}

/**
 * @additionalProperties true
 */
export type IClientProps = Record<string, unknown>;

export interface IClientInstrumentationRequest {
  type: ClientInstrumentationEventType;
  eventProps?: IClientProps;
  workspaceId?: string;
  digitalPropertyId?: string;
}
